import { IconFont } from '@/components/IconFont'
import { register } from '@/services/passport/passport.service'
import { APP_NAME } from '@/utils/constants'
import { useRequest, useTitle } from 'ahooks'
import { Button, Form, Input } from 'antd'
import React, { memo } from 'react'
import { useNavigate } from 'react-router'

export default memo(function Register() {
  useTitle(`${APP_NAME}-Register`)
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { loading, run } = useRequest(register, {
    manual: true,
    onSuccess: () => {
      const searchStr = window.location.search
      navigate(`/entrance/login${searchStr}`)
    }
  })

  return (
    <Form
      form={form}
      autoComplete='off'
      layout='vertical'
      onFinish={(values) => {
        run(values)
      }}
    >
      <Form.Item label='Full Name' name='fullName' rules={[{ required: true, message: 'Please enter Full Name' }]}>
        <Input size='large' type='text' prefix={<IconFont type={'icon-user'} />} placeholder='Enter your name' />
      </Form.Item>

      <Form.Item
        label='Email'
        name='email'
        rules={[
          { required: true, message: 'Please enter email address' },
          { type: 'email', message: 'Invalid email format' }
        ]}
      >
        <Input size='large' type='email' prefix={<IconFont type={'icon-email'} />} placeholder='Enter email address' />
      </Form.Item>

      <Form.Item
        label='Password'
        name='password'
        rules={[
          { required: true, message: 'Please enter password' },
          { min: 6, message: 'Minimum length of password is 6 digits.' },
          { max: 20, message: 'Maximum length of password is 20 digits.' }
        ]}
      >
        <Input
          size='large'
          autoComplete='new-password'
          prefix={<IconFont type={'icon-lock'} />}
          type='password'
          placeholder='Enter password'
        />
      </Form.Item>

      <Form.Item>
        <Button
          htmlType='submit'
          type='primary'
          size='large'
          loading={loading}
          style={{ width: '100%', marginBottom: '5px' }}
        >
          Sign Up
        </Button>
      </Form.Item>
    </Form>
  )
})
